/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';
import Ember from 'ember';
import { isNone } from '@ember/utils';
import { task, timeout } from 'ember-concurrency';
import moment from 'moment-timezone';

import TIME_ZONES from 'cio/utils/time-zones';

const DAY_FORMAT = 'dddd, MMMM DD, YYYY';
const TIME_FORMAT = 'h:mm A';
const TICK_DELAY = 1000;
const SCHEDULING_THRESHOLD_MINUTES = 5;

@tagName('')
export default class CioNewsletterSchedule extends Component {
  timestamp = null;
  timezone = null;
  duration = null;
  durationHumanReadable = null;
  currentTime = null;
  tzMatchEnabled = false;

  init() {
    super.init(...arguments);

    this.set('currentTime', moment.utc());
    if (!Ember.testing) {
      this.get('tick').perform();
    }
  }

  tick = task(
    {
      drop: true,
    },
    async () => {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        await timeout(TICK_DELAY);
        this.set('currentTime', moment.utc());
      }
    },
  );

  @computed('timestamp')
  get time() {
    return moment.utc(this.get('timestamp') * 1000);
  }

  @computed('time', 'timezone')
  get localTime() {
    let time = this.get('time');
    let timezone = this.get('timezone');

    let clonedTime = time.clone();

    if (!isNone(timezone)) {
      clonedTime.tz(timezone);
    }

    return clonedTime;
  }

  @computed('time', 'currentTime')
  get isPast() {
    return !this.get('time').isAfter(this.get('currentTime'));
  }

  @computed('localTime', 'currentTime')
  get isToday() {
    let localCurrentTime = this.get('currentTime').clone().local();

    return this.get('localTime').isSame(localCurrentTime, 'day');
  }

  @computed('localTime')
  get formattedDay() {
    return this.get('localTime').format(DAY_FORMAT);
  }

  @computed('localTime')
  get formattedTime() {
    return this.get('localTime').format(TIME_FORMAT);
  }

  @computed('timezone')
  get timezoneLabel() {
    let timezone = this.get('timezone');
    let timezoneObject = TIME_ZONES.findBy('value', timezone);

    return timezoneObject ? timezoneObject.label : timezone;
  }

  @computed('time', 'currentTime')
  get timeRemaining() {
    return this.get('time').preciseDiff(this.get('currentTime'));
  }

  @computed('time', 'currentTime')
  get disableScheduling() {
    let diff = this.get('time').diff(this.get('currentTime'));

    return moment.duration(diff).asMinutes() < SCHEDULING_THRESHOLD_MINUTES;
  }
}
